export const MCP_CLIENT_ROUTE_BASE = '/docs/mcp'

export type McpClientSlug =
  | 'claude-code'
  | 'claude'
  | 'codex'
  | 'gemini-cli'
  | 'cursor'
  | 'hermes-agent'
  | 'openclaw'
  | 'other-clients'
  | 'chatgpt'

export type McpClientLogo = 'claude' | 'gemini' | 'cursor' | 'hermes' | 'openclaw' | 'mcp' | 'chatgpt'

export interface McpClientDoc {
  slug: McpClientSlug
  name: string
  pageTitle: string
  sidebarLabel: string
  status: string
  description: string
  logo: McpClientLogo
  recommended?: boolean
  comingLater?: boolean
}

export const MCP_CLIENTS: McpClientDoc[] = [
  {
    slug: 'claude',
    name: 'Claude Desktop & Web',
    pageTitle: 'Claude Desktop & Web setup',
    sidebarLabel: 'Claude Desktop & Web',
    status: 'Recommended',
    description: 'Add Martini from Claude connector settings.',
    logo: 'claude',
    recommended: true,
  },
  {
    slug: 'claude-code',
    name: 'Claude Code',
    pageTitle: 'Claude Code setup',
    sidebarLabel: 'Claude Code',
    status: 'Advanced setup',
    description: 'Add Martini as a user-scoped remote MCP server from the terminal.',
    logo: 'claude',
  },
  {
    slug: 'codex',
    name: 'Codex',
    pageTitle: 'Codex setup',
    sidebarLabel: 'Codex',
    status: 'Recommended for OpenAI',
    description: 'Use Martini with Codex for reliable agent workflows.',
    logo: 'chatgpt',
    recommended: true,
  },
  {
    slug: 'gemini-cli',
    name: 'Gemini CLI',
    pageTitle: 'Gemini CLI setup',
    sidebarLabel: 'Gemini CLI',
    status: 'Supported',
    description: 'Install the Martini Gemini CLI extension.',
    logo: 'gemini',
  },
  {
    slug: 'chatgpt',
    name: 'ChatGPT',
    pageTitle: 'ChatGPT setup',
    sidebarLabel: 'ChatGPT',
    status: 'Availability varies',
    description: 'Connect from ChatGPT Apps when Martini is available to your workspace.',
    logo: 'chatgpt',
  },
  {
    slug: 'openclaw',
    name: 'OpenClaw',
    pageTitle: 'OpenClaw setup',
    sidebarLabel: 'OpenClaw',
    status: 'Supported',
    description: 'Add Martini as a hosted MCP server.',
    logo: 'openclaw',
  },
  {
    slug: 'hermes-agent',
    name: 'Hermes Agent',
    pageTitle: 'Hermes Agent setup',
    sidebarLabel: 'Hermes Agent',
    status: 'Supported',
    description: "Connect with Martini's hosted MCP URL.",
    logo: 'hermes',
  },
  {
    slug: 'cursor',
    name: 'Cursor',
    pageTitle: 'Cursor setup',
    sidebarLabel: 'Cursor',
    status: 'Supported',
    description: 'Add a remote MCP server from settings.',
    logo: 'cursor',
  },
  {
    slug: 'other-clients',
    name: 'Other MCP clients',
    pageTitle: 'Other MCP clients',
    sidebarLabel: 'Other MCP clients',
    status: 'MCP compatible',
    description: 'Generally connectable as long as the client supports hosted MCP or Streamable HTTP.',
    logo: 'mcp',
  },
]

export function getMcpClient(slug: string): McpClientDoc | undefined {
  return MCP_CLIENTS.find(client => client.slug === slug)
}

export function getMcpClientHref(client: McpClientDoc): string {
  return `${MCP_CLIENT_ROUTE_BASE}/${client.slug}`
}
